<script>
    import NavMenu from './NavMenu.svelte';
    import Session from "../../class/Session";
    import Head from "./Head.svelte";
    import {location} from "svelte-spa-router";
    import { t } from "../../i18n";

    document.body.classList = 'chat-application vertical-layout vertical-menu-modern 2-columns  navbar-sticky footer-static';

    export let title = "";


    let isActive = function(code){
        let loc = $location;
        if(loc.match(/^\/quotation\/\d+$/)) loc = '/home';
        return loc===code;
    };

</script>


<svelte:head>
    <title> { title || '-' } </title>
</svelte:head>

<!-- BEGIN: Header-->
<Head></Head>
<!-- END: Header-->


<!-- BEGIN: Main Menu-->
<div class="main-menu menu-fixed menu-light menu-accordion menu-shadow" data-scroll-to-active="true">
    <div class="navbar-header" style="height:12.6rem;">
        <ul class="nav navbar-nav flex-row">
            <li class="nav-item mr-auto">
                <a class="navbar-brand" href="..">
                    <div class="brand-logo"><img src="assets/img/logo.png" alt="Logo"></div>
                    <h2 class="brand-text mb-0"></h2>
                </a></li>
            <li class="nav-item nav-toggle"><a class="nav-link modern-nav-toggle pr-0" data-toggle="collapse"><i class="bx bx-x d-block d-xl-none font-medium-4 primary"></i>
                    <i class="toggle-icon bx bx-disc font-medium-4 d-none d-xl-block primary" style="visibility: hidden;" data-ticon="bx-disc"></i>
                </a></li>
        </ul>
    </div>
    <div class="shadow-bottom"></div>
    <div class="main-menu-content">



        <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation" data-icon-style="lines">


            <NavMenu></NavMenu>

            <li class=" navigation-header"><span>{$t('nav.support')}</span></li>

            <!--
            <li class=" nav-item" class:active={isActive('/faq')}>
                <a href="/#/faq"><i class="bx bx-help-circle"></i><span class="menu-title" data-i18n="FAQ">FAQ</span></a>
            </li>
            -->

            <li class=" nav-item" class:active={isActive('/help')}>
                <a href="/#/help"><i class="bx bx-envelope"></i><span class="menu-title" data-i18n="Help">{$t('nav.help')}</span></a>
            </li>

        </ul>

        <script>
            $('#menu-invoices-btn').on('click', function () {
                Swal.fire({
                    title: "Info!",
                    text: "There are no invoices yet!",
                    type: "info",
                    confirmButtonClass: 'btn btn-primary',
                    buttonsStyling: false,
                });
            });
        </script>


    </div>
</div>
<!-- END: Main Menu-->

<slot></slot>

<div class="sidenav-overlay"></div>
<div class="drag-target"></div>

<footer class="footer footer-static footer-light"></footer>

